<h2 class="mb-2">{{'nav.warnings' | translate}}</h2>
<app-warnings-history-table></app-warnings-history-table>
